import { Box, Button, Text, Input, Select, Tabs, TabList, Tab, TabPanels, TabPanel, FormControl, useToast } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderText } from "../../redux/actions/actions";
import { loadSchedule,addExamSchedule, getClasses, getDegrees, getExamSchedules, getSpecification, loadSessionTimings, loadSubjects, updateExamSchedule } from '../../redux/api_calls/apiCalls'
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import ScheduleRow from "./ScheduleRow";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { deleteExamSchedule } from './../../redux/api_calls/apiCalls';
import ViewScheduleRow from './ViewScheduleRow';

export default function Schedule() {
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const headerText = useSelector(state => state.headerState.headerText)
    const subjectsData = useSelector(state => state.subjectsState.subjectsData)
    const sessionTimingsData = useSelector(state => state.sessionTimingsState.sessionTimingsData)
    const classesData = useSelector(state => state.classesState.classesData)
    const [selectedValue, setSelectedValue] = useState('5')
    const [selectedClassValue, setSelectedClassValue] = useState('0')
    const [selectedDegreeValue, setSelectedDegreeValue] = useState('0')
    const [selectedSpecificationValue, setSelectedSpecificationValue] = useState('0')
    const [sessionTimings, setSessionTimings] = useState([])
    const dispatch = useDispatch()
    const daysRef = useRef()
    const classRef = useRef()
    const degreeRef = useRef()
    const specRef = useRef()
    const degreeViewRef = useRef()
    const specViewRef = useRef()
    const sessionsRef = useRef()
    const [startDate, setStartDate] = useState('')
    const [headers, setHeaders] = useState([])
    const [schedulerDimensions, setSchedulerDimensions] = useState(null);
    const { monthData, isMonthLoading } = useSelector(state => state.calendarMonthState)

    const [disableFieldId, setdisableFieldId] = useState('');
    // const [selectedTabName, setselectedTabName] = useState("Class Schedule");

    const degreeState = useSelector(state => state.degreeState.degreeData);

    const specificationState = useSelector(state => state.specificationState.specificationData);
    const examSchedulespecificationState = useSelector(state => state.specificationState.specificationData);

    const examScheduleState = useSelector(state => state.examScheduleState.getExamSchedules);
    const toast = useToast();
    const [selectedViewClassValue, setSelectedViewClassValue] = useState('0')
    const [selectedDegreeViewValue, setSelectedDegreeViewValue] = useState('0')
    const [selectedSpecificationViewValue, setSelectedSpecificationViewValue] = useState(null);
    const [scheduleSpecifications, setScheduleSpecifications] = useState([]);
    const [examSpecifications, setExamSpecifications] = useState([]);
    const [examViewSpecifications, setExamViewSpecifications] = useState([]);
     const classViewRef = useRef()
    const [examHandlerValues, setExamHandlerValues] = useState({
        subject_id: '',
        degree_id: '',
        specialization_id: '',
        time_noon: '',
        startTime: '',
        endTime: '',
        year_id: '',
        date: ''
    });
   const { scheduleData, isLoading } = useSelector(
        (state) => state.scheduleState
        );
    const [finalData, setFinalData] = useState(null);
    const [timings, setTimings] = useState([]);
    const [endDate, setEndDate] = useState('');
    const [viewStartDate, setViewStartDate] = useState('');

    useEffect(() => {
   
      if (scheduleData) {

        let entries = Object.entries(scheduleData);
        if (entries.length) {
        let columns = entries.length;
        let rows = Object.entries(entries[0][1]).length;
        let displayData = new Array(rows)
          .fill(0)
          .map((row) => new Array(columns).fill(0).map((col) => null));
        let col = 0;
        for (let dates in scheduleData) {
          
            console.log(scheduleData[dates],"scheduleData[dates][`Session${i + 1}`]");
            for (let i = 0; i < 6; i++) {
                console.log(scheduleData[dates][`Session${i}`],"tst");
                if (scheduleData[dates][`Session${i}`]) {
                     
                displayData[i][col] = scheduleData[dates][`Session${i}`];  
            }
          }
          col++;
        }
        setFinalData(displayData);
        let days = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ];
        let getDay = (date) => days[new Date(date).getDay()];
        let headerData = entries.map((date) => [
          date[0].split('-').reverse().join('-'),
          getDay(date[0]),
        ]);
        setHeaders(headerData);
        let timingsData = [
          '09:30 - 10:30',
          '11:00 - 12:00',
          '12:00 - 01:00',
          '02:00 - 03:00',
          '04:00 - 05:00',
          '05:00 - 06:00',
        ];
        setTimings(timingsData.slice(0, rows));
      } else {
        setFinalData([]);
      }
    }
  }, [scheduleData]);

 const getScheduleHandler = () => {
    if (selectedDegreeViewValue === '0') {
      alert('Please select a degree!');
      return;
    }
     if (selectedSpecificationViewValue === '0') {
      alert('Please select a degree!');
      return;
    }
    if (selectedViewClassValue === '0') {
      alert('Please select a class!');
      return;
    }
  
    if (viewStartDate === '') {
      alert('Please select start date!');
      return;
    }
    if (endDate === '') {
      alert('Please select end date!');
      return;
    }

    let weekCheck =
      Date.parse(endDate.split('-').reverse().join('-')) -
        Date.parse(viewStartDate.split('-').reverse().join('-')) >=
      604800000;

    if (weekCheck) {
      alert('Please select a duration less than or equal to 7 days');
      return;
    }
    dispatch(
      loadSchedule(
        viewStartDate.split('-').reverse().join('-'),
        endDate.split('-').reverse().join('-'),
        selectedViewClassValue === '0' ? '1' : selectedViewClassValue,
        selectedDegreeViewValue,
        selectedSpecificationViewValue
      )
    );
  };


    const getNextSessionTime = (time) => {
        let newTime = Number(time.split(':').join('')) + 100
        let newTimeString = newTime.toString()
        if (newTimeString.length === 3) {
            newTimeString = '0' + newTimeString
        }
        newTimeString = newTimeString.substring(0, 2) + ':' + newTimeString.substring(2)
        return newTimeString
    }

    const buildHandler = () => {
        if (selectedClassValue === '0') {
            alert("Please select a class")
            return
        }
        if (sessionsRef.current.value.trim() === '') {
            alert("Please enter number of sessions")
            return
        }
        if (startDate === '') {
            alert("Please select start of the week")
            return
        }
        if(degreeRef.current.value ==='0')
        {
            alert("Please select a degree")
            return
        }
        if(specRef.current.value ==='0')
        {
            alert("Please select a specialization")
            return
        }
        let datesArray = []
         let datesArray1 = []
        let date = startDate.split('-').reverse()
        for (let i = 0; i < Number(daysRef.current.value); i++) {
            let day = Number(date[2]) + i;
            let current_month =  new Date((new Date(date[0], date[1], 1)) - 1) ;
            let month = date[1];
            
            if(day>current_month.getDate())
            {
                 day =   Number(day) - current_month.getDate();
                var month_add = Number(date[1]) + 1;
                 month =  "0" + month_add;
            }
           
            datesArray.push(`${day < 10 ? '0' + day : day}-${month}-${date[0]}`)
             datesArray1.push(`${date[0]}-${month}-${day < 10 ? '0' + day : day}`)
        }
        let days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        let timings = [...sessionTimings]
        while (timings.length < Number(sessionsRef.current.value)) {
            let lastSession = timings[timings.length - 1]
            let nextSession = lastSession.split('-')
            timings.push(`${getNextSessionTime(nextSession[0])} - ${getNextSessionTime(nextSession[1])}`)
        }
        setSessionTimings(timings)
        setHeaders(datesArray.map((date, idx) => [date, days[idx]]))
        let buildArray = new Array(Number(sessionsRef.current.value)).fill(0).map(value => [...datesArray1])
        setSchedulerDimensions(buildArray)
    }

    const changeHandler = () => {
        setSelectedValue(daysRef.current.value)
    }
    const classChangeHandler = () => {
        setSelectedClassValue(classRef.current.value)
    }

    const classViewChangeHandler = () => {
        setSelectedViewClassValue(classViewRef.current.value)
    }

    const degreeChangeHandler = async () => {
            let specification = await getSpecification(degreeRef.current.value);
            setScheduleSpecifications(specification.payload);
            setSelectedDegreeValue(degreeRef.current.value)
    };
    

    const specificationChangeHandler = () => {
        setSelectedSpecificationValue(specRef.current.value)
    }

     const degreeViewChangeHandler = async() => {

            let specification = await getSpecification(degreeViewRef.current.value);
            setExamViewSpecifications(specification.payload);
            setSelectedDegreeViewValue(degreeViewRef.current.value)
     }

    const specificationViewChangeHandler = () => {
        setSelectedSpecificationViewValue(specViewRef.current.value)
    }

    const validSelection = (date) => {
        setStartDate(date)
    }

  
    const changeExamScheduleHandler = async(name, value) => {
   
        if(name=="degree_id")
        {
             let specification = await getSpecification(value);
            setExamSpecifications(specification.payload);
         }
        setExamHandlerValues({
            ...examHandlerValues,
            [name]: [value]
        });
    }

    useEffect(() => {
        dispatch(setHeaderText('Schedule'))
        dispatch(loadSubjects())
        dispatch(loadSessionTimings())
        dispatch(getClasses())
        dispatch(getDegrees())
        dispatch(getExamSchedules())
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
       
       
    }, [dispatch ])

    useEffect(() => {
      const extractTimings = () => {
        let timings = sessionTimingsData.map(val => val.time)
        setSessionTimings(timings)
    }

        if (sessionTimingsData.length > 0) {
            extractTimings()
        }
    }, [sessionTimingsData])

    useEffect(() => {
        if (startDate) {
            let selectedDay = new Date(startDate.split('-').reverse().join('-'))
            if (selectedDay.getDay() !== 1) {
                alert("Please select a Monday!")
                setStartDate('')
            }
        }
    }, [startDate]);

    const saveExamSchedule = async () => {
        if (examHandlerValues.degree_id === '') {
            alert("Please select degree")
            return
        }
        if (specificationState.length && examHandlerValues.specialization_id === '') {
            alert("Please select specialization")
            return
        }
        if (examHandlerValues.year_id === '') {
            alert("Please select year")
            return
        }
        if (examHandlerValues.date === '') {
            alert("Please select a date")
            return
        }
        if (examHandlerValues.subject_id === '') {
            alert("Please select subject")
            return
        }
        if (examHandlerValues.time_noon === '') {
            alert("Please select noon time")
            return
        }
        if (examHandlerValues.time === '') {
            alert("Please select time")
            return
        }
        else {
            let obj = {
                date: examHandlerValues.date,
                time: [`${examHandlerValues.startTime[0]} - ${examHandlerValues.endTime[0]}`],
                year_id: examHandlerValues.year_id,
                subject_id: examHandlerValues.subject_id,
                degree_id: examHandlerValues.degree_id,
                specialization_id: examHandlerValues.specialization_id,
                time_noon: examHandlerValues.time_noon
            }
            if (!specificationState.length && examHandlerValues.specialization_id === '') {
                obj.specialization_id = [null];
            }
            await dispatch(addExamSchedule(obj));
            setExamHandlerValues({
                subject_id: '',
                degree_id: '',
                specialization_id: '',
                time_noon: '',
                startTime: '',
                endTime: '',
                year_id: '',
                date: ''
            });
            toast({
                title: "Exam Schedule Added Successfully!",
                status: "success",
                position: "top-right",
                duration: 2000,
                isClosable: true,
            });
        }

    }

    const deleteExamScheduleFunc = async (id) => {
        await dispatch(deleteExamSchedule(id));
        toast({
            title: "Exam Schedule Deleted Successfully!",
            status: "success",
            position: "top-right",
            duration: 2000,
            isClosable: true,
        });
    }

    const updateSchedule = async (name, value) => {
        let obj = {
            exam_schedule_id: disableFieldId.id,
            date: disableFieldId.date,
            time: disableFieldId.time,
            year_id: disableFieldId.class_id,
            subject_id: disableFieldId.subject_id,
            degree_id: disableFieldId.degree_id,
            specialization_id: disableFieldId.specialization_id,
            time_noon: disableFieldId.time_noon
        }
        let splitTime = disableFieldId.time.split(" - ");
        obj[name] = value;
        if (name === "startTime") {
            obj["time"] = `${value} - ${splitTime[1]}`
        }
        if (name === "endTime") {
            obj["time"] = `${splitTime[0]} - ${value}`
        }
        await dispatch(updateExamSchedule(obj));
        // setdisableFieldId('');
        toast({
            title: "Exam Schedule Updated Successfully!",
            status: "success",
            position: "top-right",
            duration: 2000,
            isClosable: true,
        });
    }

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>

            {/* <Box w='80%' d='flex' alignItems='center' mb='2rem'>
                <Text
                    fontSize='22px'
                    color='#222222'
                    fontWeight='500'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                >
                    Manage Schedule
                </Text>
                <ChevronRightIcon w={8} h={8} style={{ margin: '0px 8px' }} />
                <Text
                    fontSize='22px'
                    color='#222222'
                    fontWeight='500'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                >
                    {selectedTabName}
                </Text>
            </Box> */}
            {/* EXAM SCHEDULE CODE */}
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Tabs width={['100%']} variant='unstyled' colorScheme='blue'>
                    <TabList style={{ border: 'none' }} >
                        <Tab _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ fontFamily: "Mulish, sans-serif",textTransform:"uppercase" }}>Class Schedule</Tab>
                        <Tab _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ marginLeft:'10px',fontFamily: "Mulish, sans-serif",textTransform:"uppercase"  }}>Exam Schedule</Tab>
                        <Tab _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ marginLeft:'10px',fontFamily: "Mulish, sans-serif",textTransform:"uppercase"  }}>View Schedule</Tab>
                   
                    </TabList>

                    <TabPanels>
                        <TabPanel padding="0" >
                        <Box bg='white' borderRadius='20px' py='0.2rem'
                    pl='1rem' mt='1rem' pr='1rem' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
                                
                                <Box width='32%'>
                                <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Degree
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        onChange={degreeChangeHandler}
                                        fontSize='18px'
                                        ref={degreeRef}
                                    >
                                        <option value='' key='-1'>Select Degree</option>
                                        {
                                            degreeState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                                <Box width='32%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Specialization
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        ref={specRef}
                                        onChange={specificationChangeHandler}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Specialization</option>
                                        {
                                            scheduleSpecifications.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>
                                <Box width='32%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Class
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        ref={classRef}
                                        value={selectedClassValue}
                                        onChange={classChangeHandler}
                                        fontSize='18px'
                                    >
                                        <option value='0' key='-1'>Select a Class</option>
                                        {
                                            classesData.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>
                                

                               

                            </Box>
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase" , marginTop: '32px' }}
                            >
                            <Box width='23%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' ,textTransform:"uppercase" }}
                                    >
                                        No. of Days (per week)
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        ref={daysRef}
                                        value={selectedValue}
                                        onChange={changeHandler}
                                        fontSize='18px'
                                    >
                                        <option value="5" key="1">5</option>
                                        <option value="6" key="2">6</option>
                                    </Select>
                                </Box>
                                <Box width='23%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        No. of Sessions (per day)
                                    </Text>
                                    <Input
                                        fontSize='18px'
                                        type='text'
                                        placeholder='No. of sessions'
                                        ref={sessionsRef}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                    />
                                </Box>
                             <Box width='30%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Select start of the week (Monday)
                                    </Text>

                                    <Flatpickr
                                        value={startDate}
                                        options={
                                            { 
                                            disable: ["30-01-2023,2025-01-30", "2025-02-21", "2025-03-08", new Date(2025, 4, 9) ],

                                            dateFormat: 'd-m-Y',
                                            minDate: "today"
                                             }
                                        }
                                        placeholder='dd-mm-yyyy'

                                        onChange={(date, dateStr) => validSelection(dateStr)}

                                        style={{
                                            padding: '1rem',
                                            color: '#666666',
                                            width: '100%',
                                            height: '40px',
                                            backgroundColor: 'transparent',
                                            borderRadius: '13px',
                                            border: '1px solid rgba(0, 0, 0, 0.1)'
                                        }}
                                    />

                                </Box>

                                <Box height='100%' d='flex' justifyContent='center' alignItems='flex-end'>
                                    <Button
                                        fontSize='16px'
                                        fontWeight='700'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                        colorScheme='messenger'
                                        onClick={buildHandler}
                                        marginTop='30px'
                                    >
                                        Build
                                    </Button>
                                </Box>
                                

                            </Box>
                            </Box>
                            <Box width={['100%']}  justifyContent='space-between'  borderRadius='20px' alignItems='center' d='flex' flexDir='column' mb='2rem' mt='2rem' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>

                                {!schedulerDimensions ? <Text>Please fill in the details above!</Text>
                                    : <Box w='100%' bg='white' justifyContent='space-between' alignItems='center' borderRadius='20px' d='flex' flexDir='column'>
                                        {
                                            headers.length > 0 && <Box
                                            width='100%'
                                            display='flex'
                                            justifyContent='space-between'
                                            alignItems='center'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            borderBottom='1px solid rgba(0,0,0,0.1)'
                                            bg='white'
                                            borderTopRadius='20px'

                                          >
                                            <Box
                                              flex='1'
                                              height='100px'
                                              key='-1'
                                              display='flex'
                                              flexDir='column'
                                              justifyContent='center'
                                              alignItems='center'
                                              color='blue'
                                             

                                            >
                                              <Text
                                                fontStyle='normal'
                                                lineHeight='18px'
                                                fontSize='16px'
                                                fontWeight='700'
                                                color='#999999'
                                                style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                              >
                                                <b>Timings</b>
                                              </Text>
                                            </Box>
                                                {
                                                    headers.map((day, idx) =>
                                                         <Box
                                                            flex='1'
                                                            height='100px'
                                                            key={idx}
                                                            display='flex'
                                                            flexDir='column'
                                                            justifyContent='center'
                                                            alignItems='center'
                                                            color='blue'
                                                            borderLeft='1px solid rgba(0,0,0,0.1)'

                                                          >
                                                            <Text
                                                            fontStyle='normal'
                                                            lineHeight='18px'
                                                            fontSize='16px'
                                                            fontWeight='700'
                                                            color='#999999'
                                                            style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                                            >
                                                              <b>{day[1]}</b>
                                                            </Text>
                                                            <Text
                                                                fontStyle='normal'
                                                                lineHeight='18px'
                                                                fontSize='16px'
                                                                fontWeight='700'
                                                                color='#999999'
                                                                style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                                                paddingTop='5px'
                                                            >
                                                              {day[0]}
                                                            </Text>
                                                          </Box>
                                                    )
                                                }
                                            </Box>
                                        }

                                        {
                                            schedulerDimensions.map((session, idx) => <ScheduleRow key={idx} rowNumber={idx} id={selectedClassValue}  degree={selectedDegreeValue} specification={selectedSpecificationValue}  session={session} subjects={subjectsData} time={sessionTimings[idx]} />)
                                        }
                                    </Box>
                                }
                      

                            </Box>
                 
                        </TabPanel>
                        <TabPanel padding="0">
                        <Box  bg='white' borderRadius='20px' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' py='1.5rem'
                    pl='1rem' mt='1rem' pr='1rem' >
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px' }}
                                
                            >
                                <Box width='33%'>
                                    {/* <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        Class
                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.degree_id}
                                        onChange={(e) => changeExamScheduleHandler("degree_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Degree</option>
                                        {
                                            degreeState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                                <Box width='33%'>
                                    {/* <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        No. of Days (per week)
                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.specialization_id}
                                        onChange={(e) => changeExamScheduleHandler("specialization_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Specialization</option>
                                        {
                                            examSpecifications.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>
                                <Box width='33%'>
                                    {/* <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        No. of Days (per week)
                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.year_id}
                                        onChange={(e) => changeExamScheduleHandler("year_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Year</option>
                                        {
                                            classesData.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                            </Box>
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                            >
                                <Box width='20%'>
                                    {/* <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                    >
                                        Class
                                    </Text> */}
                                    <Flatpickr
                                        value={examHandlerValues.date}
                                        options={
                                            { dateFormat: 'd-m-Y',
                                             minDate: "today",
                                             disable: [new Date()],}
                                        }
                                        placeholder='Date'
                                        onChange={(date, dateStr) => changeExamScheduleHandler("date", dateStr)}
                                        style={{
                                            padding: '1rem',
                                            color: '#666666',
                                            width: '100%',
                                            height: '40px',
                                            backgroundColor: 'transparent',
                                            borderRadius: '13px',
                                            border: '1px solid rgba(0, 0, 0, 0.1)'
                                        }}

                                    />
                                </Box>

                                <Box width='20%'>
                                    {/* <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                    >
                                        No. of Days (per week)
                                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.subject_id}
                                        onChange={(e) => changeExamScheduleHandler("subject_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Subject</option>
                                        {
                                            subjectsData.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>
                                <Box width='20%'>
                                    {/* <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                    >
                                        No. of Sessions (per day)
                                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.time_noon}
                                        onChange={(e) => changeExamScheduleHandler("time_noon", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Noon Time</option>
                                        <option value="After Noon" key="1">Afternoon</option>
                                        <option value="Fore Noon" key="2">Forenoon</option>
                                    </Select>
                                </Box>

                                <Box width='12%'>
                                    <Flatpickr
                                        value={examHandlerValues.startTime}
                                        options={
                                            {
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: "H:i",
                                                time_24hr: true,
                                                 minDate: "today"
                                            }
                                        }
                                        placeholder='Start Time'
                                        onChange={(date, dateStr) => {
                                            changeExamScheduleHandler("startTime", dateStr)
                                        }}
                                        style={{ padding: '1rem', color: '#666666', width: '90%', height: '40px', backgroundColor: '#F8F8F8', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                    />

                                </Box>
                                <Box width='12%'>
                                    <Flatpickr
                                        value={examHandlerValues.endTime}
                                        options={
                                            {
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: "H:i",
                                                time_24hr: true,
                                                minDate: "today"
                                            }
                                        }
                                        placeholder='End Time'
                                        onChange={(date, dateStr) => {
                                            changeExamScheduleHandler("endTime", dateStr)
                                        }}
                                        style={{ padding: '1rem', color: '#666666', width: '90%', height: '40px', backgroundColor: '#F8F8F8', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                    />

                                </Box>


                                <Box height='100%' d='flex' justifyContent='center' alignItems='flex-end'>
                                    <Button
                                        fontSize='16px'
                                        fontWeight='700'
                                        style={{ fontFamily: 'Mulish, sans-serif', backgroundColor: '#00b894' }}
                                        colorScheme='messenger'
                                        onClick={saveExamSchedule}
                                    >
                                        Save
                                    </Button>
                                </Box>
                            </Box>
                            </Box>
                            <Box bg='white' borderRadius='20px' py='0.2rem'
                    pl='1rem' mt='1rem' pr='1rem' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
                            {(examScheduleState || []).map((v, i) => {
                                return <Box
                                    key={i}
                                    width={["100%"]}
                                    d="flex"
                                    justifyContent="space-between"
                                    mb="1rem"
                                    style={{ marginTop: '40px' }}

                                >
                                    <Box width="20%">
                                        <FormControl>
                                            {/* <Input
                                                type="text"
                                                color="#666666"
                                                id="first_name"
                                                width="100%"
                                                borderRadius="lg"
                                                bgColor="white"
                                                disabled={disableFieldId.id !== v.id}
                                                value="01/12/2021"
                                                // value={firstNameValue}
                                                // onChange={(e) => {
                                                //     setFirstNameError(null);
                                                //     setFirstNameValue(e.target.value);
                                                // }}
                                                fontSize={["9px", "11px", "13px", "16px"]}
                                            /> */}
                                            <Flatpickr
                                                value={v.date || ""}
                                                options={
                                                    { dateFormat: 'd-m-Y' }
                                                }
                                                placeholder='dd-mm-yyyy'
                                                disabled={disableFieldId.id !== v.id}
                                                onChange={(date, dateStr) => updateSchedule("date", dateStr)}
                                                style={{
                                                    padding: '1rem',
                                                    color: '#666666',
                                                    width: '100%',
                                                    height: '40px',
                                                    backgroundColor: 'transparent',
                                                    borderRadius: '13px',
                                                    border: '1px solid rgba(0, 0, 0, 0.1)'
                                                }}
                                            />
                                        </FormControl>
                                    </Box>
                                    <Box width="20%">
                                        <FormControl>
                                            <Select
                                                id='type'
                                                width={["100%", "100%", "90%", "85%"]}
                                                border='1px solid rgba(0, 0, 0, 0.1)'
                                                borderRadius="13px"
                                                disabled={disableFieldId.id !== v.id}
                                                height='40px'
                                                value={v.subject.id}
                                                onChange={(e) => updateSchedule("subject_id", e.target.value)}
                                                fontSize='18px'
                                            >
                                                {
                                                    subjectsData.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box width="20%">
                                        <FormControl>
                                            <Select
                                                id='type'
                                                width={["100%", "100%", "90%", "85%"]}
                                                border='1px solid rgba(0, 0, 0, 0.1)'
                                                borderRadius="13px"
                                                height='40px'
                                                disabled={disableFieldId.id !== v.id}
                                                value={v.time_noon || ""}
                                                onChange={(e) => updateSchedule("time_noon", e.target.value)}
                                                fontSize='18px'
                                            >
                                                <option value="After Noon" key="1">Afternoon</option>
                                                <option value="Fore Noon" key="2">Forenoon</option>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box width="12%">
                                        <FormControl>

                                            <Flatpickr
                                                value={v.time.split(" - ")[0]}
                                                options={
                                                    {
                                                        enableTime: true,
                                                        noCalendar: true,
                                                        dateFormat: "H:i",
                                                        time_24hr: true
                                                    }
                                                }
                                                disabled={disableFieldId.id !== v.id}
                                                placeholder='hh:mm'
                                                onChange={(date, dateStr) => {
                                                    updateSchedule("startTime", dateStr)
                                                }}

                                                style={{ padding: '1rem', color: '#666666', width: '90%', height: '40px', backgroundColor: '#F8F8F8', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                            />
                                            {/* <Input
                                                type="text"
                                                color="#666666"
                                                id="last_name"
                                                width="100%"
                                                borderRadius="lg"
                                                bgColor="#F8F8F8"
                                                disabled={disableFieldId.id !== v.id}
                                                value={v.time}
                                                fontSize={["9px", "11px", "13px", "16px"]}
                                                onChange={(e) => {
                                                    updateSchedule("time", e.target.value)
                                                }}
                                            /> */}
                                        </FormControl>
                                    </Box>
                                    <Box width="12%">
                                        <FormControl>

                                            <Flatpickr
                                                value={v.time.split(" - ")[1]}
                                                options={
                                                    {
                                                        enableTime: true,
                                                        noCalendar: true,
                                                        dateFormat: "H:i",
                                                        time_24hr: true
                                                    }
                                                }
                                                disabled={disableFieldId.id !== v.id}
                                                placeholder='hh:mm'
                                                onChange={(date, dateStr) => {
                                                    updateSchedule("endTime", dateStr)
                                                }}

                                                style={{ padding: '1rem', color: '#666666', width: '90%', height: '40px', backgroundColor: '#F8F8F8', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                            />
                                            {/* <Input
                                                type="text"
                                                color="#666666"
                                                id="last_name"
                                                width="100%"
                                                borderRadius="lg"
                                                bgColor="#F8F8F8"
                                                disabled={disableFieldId.id !== v.id}
                                                value={v.time}
                                                fontSize={["9px", "11px", "13px", "16px"]}
                                                onChange={(e) => {
                                                    updateSchedule("time", e.target.value)
                                                }}
                                            /> */}
                                        </FormControl>
                                    </Box>
                                    <Box d="flex"
                                        justifyContent="flex-end" width="10%" style={{ marginTop: '4px' }}>
                                        <EditIcon w={6} h={6} color="#1A202C" onClick={() => setdisableFieldId(v)} cursor="pointer" />
                                        <DeleteIcon onClick={() => deleteExamScheduleFunc(v.id)} style={{ marginLeft: '16px' }} w={6} h={6} color="#1A202C" cursor="pointer" />
                                    </Box>
                                </Box>
                            })}
                            </Box>



                        </TabPanel>
                          <TabPanel padding='0'>
              <Box bg='white' borderRadius='20px' py='0.2rem'
                    pl='1rem' mt='1rem' pr='1rem' mb="2rem" boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
              <Box width='32%'>
                                <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Degree
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        onChange={degreeViewChangeHandler}
                                        fontSize='18px'
                                        ref={degreeViewRef}
                                    >
                                        <option value='' key='-1'>Select Degree</option>
                                        {
                                            degreeState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                                <Box width='32%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Specialization
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        ref={specViewRef}
                                        onChange={specificationViewChangeHandler}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Specialization</option>
                                        {
                                            examViewSpecifications.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                <Box width='35%'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Class
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '95%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    ref={classViewRef}
                    value={selectedViewClassValue}
                    onChange={classViewChangeHandler}
                    fontSize='18px'
                  >
                    <option value='0' key='-1'>
                      Select a Class
                    </option>
                    {classesData.map((className, idx) => (
                      <option value={className.id} key={idx}>
                        {className.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                </Box>
                 <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='4rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
                <Box width='40%' mr='1rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Start Date
                  </Text>

                  <Flatpickr
                    value={viewStartDate}
                    options={{ dateFormat: 'd-m-Y' }}
                    placeholder='dd-mm-yyyy'
                   
                    onClick={(date, dateStr, instance) => {
                      setViewStartDate(dateStr);
                    }}
                    onChange={(date, dateStr, instance) => {
                      setViewStartDate(dateStr);
                    }}
                    style={{
                      padding: '1rem',
                      color: '#666666',
                      width: '100%',
                      height: '40px',
                      backgroundColor: 'transparent',
                      borderRadius: '13px',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Box>

                <Box width='40%' mr='1rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select End Date
                  </Text>

                  <Flatpickr
                    value={endDate}
                    options={{ dateFormat: 'd-m-Y' }}
                    placeholder='dd-mm-yyyy'
                   onChange={(date, dateStr, instance) => {
                      setEndDate(dateStr);
                    }}
                    onClick={(date, dateStr, instance) => {
                      setEndDate(dateStr);
                    }}
                    style={{
                      padding: '1rem',
                      color: '#666666',
                      width: '100%',
                      height: '40px',
                      backgroundColor: 'transparent',
                      borderRadius: '13px',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Box>

                <Box
                  height='100%'
                  d='flex'
                  justifyContent='center'
                  alignItems='flex-end'
                >
                  <Button
                    fontSize='16px'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    colorScheme='messenger'
                    isLoading={isLoading}
                    loadingText='Fetching...'
                    onClick={getScheduleHandler}
                  >
                    Get Schedule
                  </Button>
                </Box>
              </Box>
                                              </Box>


              <Box width={['100%']} bg='white' borderRadius='20px' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' 
                    pl='1rem'  pr='2rem'  justifyContent='flex-start' alignItems='center' flexDir='column' d='flex' mb='2rem'>
                {finalData && finalData.length > 0 ? (
                   <Box w='100%' justifyContent='space-between' alignItems='center' d='flex' flexDir='column'>

                    {headers.length > 0 && (
                      <Box
                        width='100%'
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderRadius='20px'
                      >
                        <Box
                          flex='1'
                          height='100px'
                          display='flex'
                          flexDir='column'
                          justifyContent='center'
                          alignItems='center'
                          color='black'

                        >
                          <Text
                            fontStyle='normal'
          lineHeight='18px'
          fontSize='16px'
          fontWeight='700'
          color='black'
          style={{ fontFamily: 'Mulish, sans-serif'  }}
                          >
                            <b>Timings</b>
                          </Text>
                        </Box>
                        {headers.map((day, idx) => (
                          <Box
                            flex='1'
                            height='100px'
                            key={idx}
                            display='flex'
                            flexDir='column'
                            justifyContent='center'
                            alignItems='center'
                            color='black'
                            borderLeft='1px solid rgba(0, 0, 0, 0.1)'
                            borderBottom='1px solid rgba(0, 0, 0, 0.1)'
                          >
                            <Text
                              fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='black'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                            >
                              <b>{day[1]}</b>
                            </Text>
                            <Text
                              fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='black'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                            >
                              {day[0]}
                            </Text>
                          </Box>
                        ))}
                      </Box>
                    )}

                    {finalData &&
                      finalData.map((session, idx) => (
                        <ViewScheduleRow
                          key={idx}
                          id={idx}
                          session={session}
                          time={timings[idx]}
                        />
                      ))}
                  </Box>
                ) : (
                  <Box
                    w='100%'
                    justifyContent='space-between'
                    alignItems='center'
                    d='flex'
                    flexDir='column'
                  >
                    <Text>
                      No Schedule Available for selected Class/Date-Range
                    </Text>
                  </Box>
                )}
              </Box>
            </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>




        </Box>
    )
}